import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: 'date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    standalone: false
})
export class DatePickerComponent{
    @Input() control = new FormControl();
    @Input() label = '';
    @Input() required = false;
    @Input() maxDate!: Date;
}